// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__txnGU","inputWrap":"CustomTip_inputWrap__3q8ai"};